import { render, staticRenderFns } from "./PopUpUpdateFitnessData.vue?vue&type=template&id=1d3a21b7"
import script from "./PopUpUpdateFitnessData.vue?vue&type=script&lang=js"
export * from "./PopUpUpdateFitnessData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports